/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDetail } from '../../models/customer-detail';

export interface GetCustomerById$Params {
  id: string;
}

export function getCustomerById(http: HttpClient, rootUrl: string, params: GetCustomerById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDetail>> {
  const rb = new RequestBuilder(rootUrl, getCustomerById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerDetail>;
    })
  );
}

getCustomerById.PATH = '/api/customers/{id}';
